export const normalizeGstStateCode = (code) => {
  if (code == null || code === '') return '';
  const n = parseInt(code, 10);
  if (Number.isNaN(n)) return String(code);
  return n <= 9 ? `0${n}` : String(n);
};

export const validateGstPanState = ({ gstNo, panNo, stateGstCode }) => {
  const gst = (gstNo || '').toUpperCase().trim();
  const pan = (panNo || '').toUpperCase().trim();
  if (!gst || !stateGstCode) return { valid: true, message: '' };

  const expected = normalizeGstStateCode(stateGstCode);
  if (gst.substring(0, 2) !== expected) {
    return { valid: false, message: 'GST number and state code do not match' };
  }
  if (pan && pan !== 'PANNOTAVBL' && gst.substring(2, 12) !== pan) {
    return { valid: false, message: 'GST number and PAN number do not match' };
  }
  return { valid: true, message: '' };
};

export const isGstExempt = (registrationTypeId) =>
  String(registrationTypeId) === '3';

export const VENDOR_ADDRESS_MAX_LENGTH = 40;
export const VENDOR_BENEFICIARY_NAME_MAX_LENGTH = 40;

export const getMaxLengthError = (label, maxLength = VENDOR_ADDRESS_MAX_LENGTH) =>
  `${label} must not exceed ${maxLength} characters`;

export const validateFieldMaxLength = (value, label, maxLength = VENDOR_ADDRESS_MAX_LENGTH) => {
  if (String(value || '').length > maxLength) {
    return getMaxLengthError(label, maxLength);
  }
  return '';
};

export const validateVendorOnboardingFieldLengths = (form = {}) => {
  const errors = {};
  const addressError = validateFieldMaxLength(
    form.vendor_address,
    'Address Line 1',
    VENDOR_ADDRESS_MAX_LENGTH
  );
  const address2Error = validateFieldMaxLength(
    form.vendor_address2,
    'Address Line 2',
    VENDOR_ADDRESS_MAX_LENGTH
  );
  const beneficiaryError = validateFieldMaxLength(
    form.beneficiary_name,
    'Beneficiary Name',
    VENDOR_BENEFICIARY_NAME_MAX_LENGTH
  );

  if (addressError) errors.vendor_address = addressError;
  if (address2Error) errors.vendor_address2 = address2Error;
  if (beneficiaryError) errors.beneficiary_name = beneficiaryError;

  return errors;
};

export const validateVendorAddressFieldLengths = (form = {}) => {
  const errors = {};
  const addressError = validateFieldMaxLength(
    form.address,
    'Address Line 1',
    VENDOR_ADDRESS_MAX_LENGTH
  );
  const address2Error = validateFieldMaxLength(
    form.address2,
    'Address Line 2',
    VENDOR_ADDRESS_MAX_LENGTH
  );

  if (addressError) errors.address = addressError;
  if (address2Error) errors.address2 = address2Error;

  return errors;
};

export const validateVendorBankBeneficiaryName = (beneficiaryName) =>
  validateFieldMaxLength(
    beneficiaryName,
    'Beneficiary Name',
    VENDOR_BENEFICIARY_NAME_MAX_LENGTH
  );
